"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var functions_1 = require("../../utils/functions");
exports.ClickOutside = function (_a) {
    var children = _a.children, condition = _a.condition, _b = _a.onClickOutside, onClickOutside = _b === void 0 ? functions_1.NOOP : _b, _c = _a.className, className = _c === void 0 ? undefined : _c;
    var containerRef = React.useRef(null);
    React.useEffect(function () {
        handleListeners();
        return removeListener;
    });
    var handleListeners = function () {
        if (condition) {
            setListener();
        }
        else {
            removeListener();
        }
    };
    var setListener = function () {
        setTimeout(function () {
            window.addEventListener('click', _onClickOutside);
        }, 50);
    };
    var removeListener = function () {
        window.removeEventListener('click', _onClickOutside);
    };
    var _onClickOutside = function (e) {
        var ref = containerRef.current;
        if (!ref || !e.target)
            return;
        var target = e.target;
        if (!ref.contains(target)) {
            onClickOutside(e);
        }
    };
    return (React.createElement("div", { className: className, ref: containerRef }, children));
};
